/**
 * ResponsavelWebhook
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {TypeWebhook} from '@/model/resource/TypeWebhook'
import {ResponsavelWebhookCollection} from '@/model/collection/ResponsavelWebhookCollection'

/* TODO: review generated class */
export class ResponsavelWebhook extends Resource {
  idWebhookPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(TypeWebhook)
  typeWebhook: TypeWebhook | null = null

  url: string | null = null
  idTypeFk: number | null = null

  get $id() {
    return this.idWebhookPk
  }
  set $id(val) {
    this.idWebhookPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelWebhook
   */
  async getResponsavelWebhook(id: number) {
    return await Request.get(`/admin/responsavel-webhook/${id}`)
      .name('getResponsavelWebhook')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponsavelWebhook
   */
  static async listResponsavelWebhook(params: any) {
    return await Request.get(`/admin/responsavel-webhook`, {params})
      .name('listResponsavelWebhook')
      .as(ResponsavelWebhookCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelWebhook. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelWebhook() {
    return await Request.post(`/admin/responsavel-webhook`, this)
      .name('persistResponsavelWebhook')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelWebhook to use it in a CSV file
   */
  static async listCsvResponsavelWebhook(params: any) {
    return await Request.get(`/admin/responsavel-webhook/csv`, {params})
      .name('listCsvResponsavelWebhook')
      .as(ResponsavelWebhookCollection)
      .getData()
  }
}
